import { concat } from 'lodash';
import React, { FC } from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from 'src/context/ApplicationContext';
import { PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import { FormStrucItem } from 'src/lib/types/types';
import ApplicationHeading from 'src/pages/private/online-antrag/application-heading/ApplicationHeading';

// import schemas
import VerwendungsnachweisSchema from 'src/lib/paths/verwendungsnachweis_FULL_Paths.json';
const VN_P = VerwendungsnachweisSchema.attributes;

const EmobLisSachbericht: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	return (
		<>
			<ApplicationHeading title='Sachbericht' description={PLATZHALTER_TEXT} />

			<CreateForm formStruc={formStruc()} formValues={application} updateFormValuesFunc={setApplicationProperty} readOnly={readOnly} />
		</>
	);
};

export default EmobLisSachbericht;

const formStruc = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				VN_P.Sachbericht_Emob_Lis_Einrichtungort,
				VN_P.Sachbericht_Emob_Lis_Anzahl_Ladepunkte,
				VN_P.Sachbericht_Emob_Lis_Ladeleistung,
				VN_P.Sachbericht_Emob_Lis_Anschlussleistung,
				VN_P.Sachbericht_Emob_Lis_Schilderung,
				VN_P.Sachbericht_Emob_Lis_Herausforderung,
			],
			userProps: { columnToDivide: 1, direction: 'column' },
		},
	];
	return struc;
};

export const getFormStrucEmobLisSachbericht = () => {
	return concat(formStruc());
};
